import { render, staticRenderFns } from "./BackgroundView.vue?vue&type=template&id=789c4e03&scoped=true&"
import script from "./BackgroundView.vue?vue&type=script&lang=js&"
export * from "./BackgroundView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c4e03",
  null
  
)

export default component.exports